/**
 * What every column on every form is: core-api's generated rules, plus the hand-written rules
 * for forms only the e-file app files (fieldRules.manual.ts).
 *
 * Read rules through this file, not fieldRules.generated.ts, so a hand-written form is seen
 * everywhere the generated ones are: record checks, the zod shape, box totals and the API.
 * A hand-written rule wins over a generated one for the same column.
 */
import { fieldRules as generatedFieldRules } from "./fieldRules.generated";
import type { FormFieldRules } from "./fieldRules.generated";
import { MANUAL_FIELD_RULES } from "./fieldRules.manual";

export type { FieldKind, FieldRule, FormFieldRules } from "./fieldRules.generated";

/** The rules for one form in one tax year. */
export function fieldRules(formType: string, taxYear: number): FormFieldRules {
  const generated = generatedFieldRules(formType, taxYear);
  const manual = MANUAL_FIELD_RULES[formType];
  return manual ? { ...generated, ...manual } : generated;
}

/** True when this column holds money on this form. */
export function isAmountField(formType: string, taxYear: number, field: string): boolean {
  return fieldRules(formType, taxYear)[field]?.kind === "amount";
}
